import { Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { bodyTextProps } from '../utils';
import { NachversandCard } from './NachversandCard';
import { Part2BookingButton } from './Part2BookingButton';

export const BookableCard = () => {
  const { t } = useTranslation('versand');

  return (
    <NachversandCard title={t('Bookable.Title')}>
      <Text {...bodyTextProps}>{t('Bookable.Description')}</Text>
      <Part2BookingButton label={t('Bookable.Button')} />
      <Text {...bodyTextProps}>{t('BringAlong')}</Text>
    </NachversandCard>
  );
};
